<script>
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellNumErrorsPerTech',
    extends: TableCellBase,
    computed: {
      actualValueRaw() {
        return this.round(this.getRatio(this.monthObj['num_errors'], this.monthObj['num_techs']), 2);
      },
    },
  };
</script>
